/**
 * okbye.ca \u2014 Free Gift + Upsell Cart Drawer (v6)
 * + Free shipping bar style Rhode
 * + T-shirt gratuit style Kylie (en haut du drawer)
 */

(function () {

  console.log("%c[okbye] side cart COORDINATEUR v31 charg\u00e9", "color:#fff;background:#D94F3D;padding:2px 6px;border-radius:4px");

  // \u2500\u2500\u2500 CONFIG \u2014 MODIFIER ICI \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500

  // OK BYE : réglages du thème (snippets/okbye-cart-config.liquid, rendu dans layout/theme.liquid)
  // Paramètres du thème > Ok Bye > « Panier : cadeau » / « Panier : Complète ton ambiance »
  function readConfig() {
    try {
      var el = document.getElementById("okbye-cart-config");
      if (el) return JSON.parse(el.textContent || "{}") || {};
    } catch (e) { console.log("[okbye] config panier illisible", e); }
    return {};
  }
  var CFG = readConfig();
  var CFG_TEXTS = CFG.texts || {};
  var TEXT_BANNER = CFG_TEXTS.banner || "Cadeau inclus — ajouté à chaque commande";
  var TEXT_PROGRESS = CFG_TEXTS.progress || "Plus que {montant} pour ton cadeau";
  var UPSELL_HEADING = (CFG.upsell && CFG.upsell.heading) || "Complète ton ambiance Ok Bye";

  // OK BYE : ancien cadeau codé en dur — secours si aucun produit n'est choisi dans l'éditeur,
  // et toujours reconnu comme « cadeau » pour les paniers qui le contiennent déjà.
  var LEGACY_GIFT = {
    variantId: 46695759610055,
    handle: "sent-bon-gratuit",
    displayLabel: "Sent-bon",
  };

  // Cadeau inclus automatiquement (style Kylie) — produit choisi dans l'éditeur, sinon le Sent-bon
  var CFG_GIFT = CFG.gift || null;
  var INCLUDED_GIFT = (CFG_GIFT && CFG_GIFT.variantId)
    ? {
        variantId: CFG_GIFT.variantId,
        productId: CFG_GIFT.productId || null,
        handle: CFG_GIFT.handle,
        displayLabel: CFG_GIFT.title || LEGACY_GIFT.displayLabel,
        image: CFG_GIFT.image || "",
        available: CFG_GIFT.available !== false,
      }
    : {
        variantId: LEGACY_GIFT.variantId,
        productId: null,
        handle: LEGACY_GIFT.handle,
        displayLabel: LEGACY_GIFT.displayLabel,
        image: "",
        available: true,
      };
  var GIFTS = [INCLUDED_GIFT];

  // OK BYE : montant minimum (en dollars dans l'éditeur → centimes ici). 0 = ajouté à chaque commande.
  var GIFT_MIN_CENTS = Math.max(0, Math.round((parseFloat(CFG.minAmount) || 0) * 100));
  function giftThresholdCents() {
    // Conversion si le client paie dans une autre devise (Shopify Markets)
    var rate = (window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate)) || 1;
    return Math.round(GIFT_MIN_CENTS * rate);
  }

  var UPSELLS = [
    { variantId: null, handle: "awaye-lache-ton-cell-pis-etudie-menthe-poivree-jasmin-fleur-de-citronnier", displayLabel: "Jasmin & Menthe Poivr\u00e9e", badge: "Bougie du mois" },
    { variantId: null, handle: "la-pince-signature",                    displayLabel: "La Pince Signature" },
    { variantId: null, handle: "le-porte-cles-espresso-martini",        displayLabel: "Le Porte-Cl\u00e9s Espresso Martini" },
    { variantId: null, handle: "pina-colada-chocolats-favoris-x-ok-bye", displayLabel: "Pi\u00f1a Colada" },
    { variantId: null, handle: "sans-titre-12juil-_22-24-36",           displayLabel: "La mitaine de four" },
    { variantId: null, handle: "briquet-electrique-rechargeable",       displayLabel: "Le Briquet \u00c9lectrique Rechargeable" },
  ];

  // T-shirt gratuit (style Kylie)
  var TSHIRT = {
    variantId: 46666125508807,
    handle: "docapp-free-gift-t-shirt-gratuit",
    displayLabel: "T-Shirt Ok Bye GRATUIT",
    threshold: 9900,   // 99$ en centimes
    comparePrice: "44,95 $",
    description: "D\u00e9pense encore %REMAINING% pour d\u00e9bloquer ton t-shirt gratuit!",
    unlockedMsg: "Ton t-shirt gratuit est d\u00e9bloqu\u00e9 \u2014 ajoute-le \u00e0 ta commande!",
  };

  // Seuils
  var FREE_SHIPPING_THRESHOLD = 12500; // 125$

  // Texte d\u00e9tails cadeau
  var DETAILS_TEXT = "Re\u00e7ois un cadeau gratuit avec chaque commande, pendant les stocks disponibles. Choisis entre un sent-bon ou une cuill\u00e8re \u00e0 cr\u00e8me glac\u00e9e. Le cadeau est ajout\u00e9 automatiquement \u00e0 ta commande \u2014 aucun code requis. Non \u00e9changeable, non remboursable.";

  // \u2500\u2500\u2500 STATE \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500

  // OK BYE : toutes les variantes reconnues comme « cadeau » (produit choisi + ancien Sent-bon)
  var GIFT_VARIANT_IDS = [];
  [INCLUDED_GIFT.variantId, LEGACY_GIFT.variantId].concat((CFG_GIFT && CFG_GIFT.variantIds) || []).forEach(function(id) {
    id = Number(id);
    if (id && GIFT_VARIANT_IDS.indexOf(id) === -1) GIFT_VARIANT_IDS.push(id);
  });
  var ALL_FREE_IDS = GIFT_VARIANT_IDS.slice();
  var selectedGiftIndex = 0;
  var currentUpsellIndex = 0;
  var giftImages = {};
  var upsellImages = {};
  var upsellPrices = {};
  var upsellOnSale = {};
  var upsellCompare = {};
  var upsellAddVariant = {};
  var upsellVariants = {};      // OK BYE v70 : formats disponibles (menu de format)
  var changeListenerAttached = false;
  var currentCartVariantIds = [];
  var currentCartProductIds = [];
  var cartIsEmpty = false;
  var giftAddBlockedUntil = 0;   // OK BYE : pause après un ajout refusé (ex. cadeau épuisé)
  var autoActionTimes = [];      // OK BYE : disjoncteur anti-boucle (ajouts/retraits automatiques)
  var tshirtImage = "";
  var imagesLoaded = false;
  var clickListenerAttached = false;
  var detailsOpen = false;

  // OK BYE : image du cadeau déjà fournie par Liquid → pas besoin de la charger
  if (INCLUDED_GIFT.image) { giftImages[INCLUDED_GIFT.handle] = INCLUDED_GIFT.image; INCLUDED_GIFT.preloaded = true; }

  // OK BYE : carrousel « Complète ton ambiance » — collection choisie dans l'éditeur.
  // Si la collection est vide / non choisie → on garde la liste UPSELLS ci-dessus.
  (function applyUpsellConfig() {
    var list = (CFG.upsell && CFG.upsell.products) || [];
    var mapped = [];
    list.forEach(function(p) {
      if (!p || !p.handle || !p.variantId) return;
      var vid = Number(p.variantId);
      if (GIFT_VARIANT_IDS.indexOf(vid) !== -1) return;
      if (INCLUDED_GIFT.productId && Number(p.productId) === Number(INCLUDED_GIFT.productId)) return;
      upsellImages[p.handle] = p.image || "";
      upsellAddVariant[p.handle] = vid;
      if (p.variants && p.variants.length) upsellVariants[p.handle] = p.variants;
      if (typeof p.price === "number") upsellPrices[p.handle] = p.price;
      if (p.compare && p.compare > p.price) { upsellCompare[p.handle] = p.compare; upsellOnSale[p.handle] = true; }
      else { upsellOnSale[p.handle] = false; }
      mapped.push({ variantId: vid, productId: Number(p.productId) || null, handle: p.handle, displayLabel: p.title || p.handle, preloaded: true, options: !!p.options, url: p.url || "" });
    });
    if (mapped.length) UPSELLS = mapped;
  })();

  // OK BYE : une ligne est « le cadeau » si elle porte _okbye_gift, si c'est le produit choisi,
  // ou si c'est une variante cadeau connue (dont l'ancien Sent-bon). _gift seul = T-shirt, ignoré ici.
  // Sécurité : si le produit choisi est aussi vendu normalement, une ligne PAYANTE sans propriété
  // cadeau n'est jamais traitée comme cadeau (sinon on bloquerait la quantité d'un vrai achat).
  function isGiftLine(item) {
    var props = item.properties || {};
    if (props._okbye_gift) return true;
    if (item.variant_id === LEGACY_GIFT.variantId) return true;
    var matches = GIFT_VARIANT_IDS.indexOf(item.variant_id) !== -1 ||
      (INCLUDED_GIFT.productId && Number(item.product_id) === Number(INCLUDED_GIFT.productId));
    if (!matches) return false;
    return !!props._gift || Number(item.original_price) === 0;
  }
  // Ligne du cadeau ACTUEL (pas un ancien cadeau resté dans le panier après un changement dans l'éditeur)
  function isCurrentGiftLine(item) {
    if (item.variant_id === INCLUDED_GIFT.variantId) return true;
    return !!(INCLUDED_GIFT.productId && Number(item.product_id) === Number(INCLUDED_GIFT.productId));
  }

  // OK BYE : disjoncteur — max 4 ajouts/retraits automatiques en 20 s, sinon on arrête (évite toute boucle)
  function canAutoAct() {
    var now = Date.now();
    autoActionTimes = autoActionTimes.filter(function(t) { return now - t < 20000; });
    if (autoActionTimes.length >= 4) {
      console.warn("[okbye] cadeau : trop d'actions automatiques, pause de sécurité");
      return false;
    }
    autoActionTimes.push(now);
    return true;
  }

  function escapeHtml(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function(c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  // Montant court pour les messages : 25 $ / 24,50 $
  function formatMoneyShort(cents) {
    cents = Math.max(0, Math.round(cents));
    return (cents % 100 === 0 ? String(cents / 100) : (cents / 100).toFixed(2).replace(".", ",")) + " $";
  }

  // \u2500\u2500\u2500 IMAGES \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500

  async function loadImages() {
    if (imagesLoaded) return;
    // OK BYE : les produits déjà fournis par Liquid (preloaded) ne sont pas re-téléchargés
    var all = GIFTS.concat(UPSELLS).filter(function(p) { return !p.preloaded; });
    await Promise.all(all.map(async function(p) {
      try {
        var res = await fetch("/products/" + p.handle + ".js");
        var data = await res.json();
        var img = data.featured_image || (data.images && data.images[0] && data.images[0].src) || "";
        if (p.variantId === TSHIRT.variantId) {
          tshirtImage = img;
        } else if (GIFT_VARIANT_IDS.indexOf(p.variantId) !== -1) {
          giftImages[p.handle] = img;
        } else {
          upsellImages[p.handle] = img;
          var variants = data.variants || [];
          var avail = variants.filter(function(x){ return x.available; });
          avail.sort(function(a, b){ return a.price - b.price; });
          var chosen = avail[0] || null;
          if (chosen) {
            upsellAddVariant[p.handle] = chosen.id;
            if (typeof chosen.price === "number") upsellPrices[p.handle] = chosen.price;
            var cmp = chosen.compare_at_price;
            if (cmp && cmp > chosen.price) { upsellCompare[p.handle] = cmp; upsellOnSale[p.handle] = true; }
            else { upsellOnSale[p.handle] = false; }
          }
        }
      } catch(e) {}
    }));
    imagesLoaded = true;
  }

  // \u2500\u2500\u2500 CART API \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace(".", ",") + " $";
  }

  async function fetchCart() {
    var res = await fetch("/cart.js");
    return res.json();
  }

  async function addToCart(variantId, properties) {
    var res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: 1, properties: properties || {} }),
    });
    var data = await res.json();
    if (!res.ok) throw new Error(data.description || "Erreur");
    return data;
  }

  // OK BYE : retire toutes les lignes cadeau (par clé de ligne)
  async function removeGiftLines() {
    var cart = await fetchCart();
    var updates = {};
    cart.items.forEach(function(item) {
      if (isGiftLine(item)) updates[item.key] = 0;
    });
    if (!Object.keys(updates).length) return false;
    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates: updates }),
    });
    return true;
  }

  // OK BYE : état du panier — le cadeau est EXCLU du montant utilisé pour le seuil
  function cartState(cart) {
    var st = { hasGift: false, hasTshirt: false, hasReal: false, realTotal: 0 };
    cart.items.forEach(function(i) {
      if (isGiftLine(i)) { st.hasGift = true; return; }
      if (i.variant_id === TSHIRT.variantId) st.hasTshirt = true;
      st.hasReal = true;
      st.realTotal += i.final_line_price;
    });
    currentCartVariantIds = cart.items.map(function(i){ return i.variant_id; });
    currentCartProductIds = cart.items.map(function(i){ return i.product_id; });
    return st;
  }

  // Anti-exploit: garde au MAX 1 cadeau (parmi les options) + MAX 1 t-shirt, peu importe comment le client a trich\u00e9
  // OK BYE : on garde UNE ligne du cadeau actuel (qté 1) ; les anciens cadeaux (produit changé
  // dans l'éditeur) et les doublons sont retirés. Mises à jour par clé de ligne (item.key).
  async function enforceGiftLimits(cart) {
    var updates = {};
    var changed = false;
    var keep = null;
    cart.items.forEach(function(i) {
      if (!keep && isGiftLine(i) && isCurrentGiftLine(i)) keep = i;
    });
    cart.items.forEach(function(i) {
      if (isGiftLine(i)) {
        if (i === keep) {
          if (i.quantity > 1) { updates[i.key] = 1; changed = true; }
        } else {
          updates[i.key] = 0; changed = true;
        }
      } else if (i.variant_id === TSHIRT.variantId && i.quantity > 1) {
        updates[i.key] = 1; changed = true;
      }
    });
    if (!changed) return false;
    try {
      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates: updates }),
      });
      return true;
    } catch(e) { return false; }
  }

  async function refreshNativeCart() {
    return new Promise(function(resolve) {
      fetch("/?sections=mini-cart")
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var html = data["mini-cart"];
          if (html) {
            var el = document.getElementById("mini-cart");
            if (el) {
              el.innerHTML = new DOMParser()
                .parseFromString(html, "text/html")
                .querySelector(".shopify-section").innerHTML;
            }
          }
          resolve();
        })
        .catch(function() { resolve(); });
    });
  }

  // \u2500\u2500\u2500 SYNC \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500

  var isSyncing = false;
  var syncTimer = null;
  function debouncedSync(delay) { clearTimeout(syncTimer); syncTimer = setTimeout(syncAndRender, delay || 400); }

  var pendingSync = false;
  async function syncAndRender() {
    if (isSyncing) {
      // Don't drop - schedule a retry after current sync finishes
      pendingSync = true;
      return;
    }
    isSyncing = true;
    pendingSync = false;
    try {
    // Fetch images in background - don't block rendering
    if (!imagesLoaded) loadImages().then(function() {
      // Re-render once images are ready if drawer is open
      var w = document.getElementById("okbye-gift-widget");
      if (w) debouncedSync(50);
    });
    var cart = await fetchCart();
    // Garde-fou anti-exploit avant tout rendu
    if (await enforceGiftLimits(cart)) {
      await refreshNativeCart();
      cart = await fetchCart();
    }
    var st = cartState(cart);
    var threshold = giftThresholdCents();
    cartIsEmpty = !st.hasReal;

    // OK BYE : admissible = au moins un vrai produit ET (seuil 0 OU montant hors cadeau >= seuil).
    // Panier sans vrai produit \u2192 pas admissible \u2192 cadeau retir\u00e9 (anti-checkout 0 $), comme avant.
    var eligible = st.hasReal && st.realTotal >= threshold;

    if (st.hasGift && !eligible) {
      // Sous le seuil (ou panier vide) \u2192 retrait automatique du cadeau
      if (canAutoAct()) {
        try {
          if (await removeGiftLines()) {
            await refreshNativeCart();
            cart = await fetchCart();
            st = cartState(cart);
          }
        } catch(e) {}
      }
    } else if (!st.hasGift && eligible && INCLUDED_GIFT.available && Date.now() > giftAddBlockedUntil) {
      // Seuil atteint (ou 0) \u2192 ajout automatique, UNE fois ; marqu\u00e9 _okbye_gift (+ _gift pour compatibilit\u00e9)
      if (canAutoAct()) {
        try {
          await addToCart(INCLUDED_GIFT.variantId, { _gift: "true", _okbye_gift: "true" });
          await refreshNativeCart();
          cart = await fetchCart();
          st = cartState(cart);
        } catch(e) {
          // Ajout refus\u00e9 (\u00e9puis\u00e9, supprim\u00e9\u2026) \u2192 on ne r\u00e9essaie pas avant 60 s
          giftAddBlockedUntil = Date.now() + 60000;
        }
      }
    }

    renderAll(cart, st.realTotal, st.hasGift, false, threshold);
    document.dispatchEvent(new CustomEvent("okbye:cart-ready", { detail: { cart: cart } }));
    if (window.okbyeShippingBarRender) window.okbyeShippingBarRender(cart);
    } catch(e) { console.log('[okbye]', e); } finally { isSyncing = false; if (pendingSync) { pendingSync = false; debouncedSync(100); } }
  }

  // \u2500\u2500\u2500 WIDGET ROOT \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500

  function removeWidget() {
    ["okbye-shipping-bar", "okbye-tshirt-bloc", "okbye-gift-widget", "okbye-included-gift"].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.remove();
    });
    clickListenerAttached = false;
  }

  function renderAll(cart, realTotal, hasGift, hasTshirt, threshold) {
    var drawer = document.querySelector("#mini-cart, .mini-cart, [data-mini-cart]");
    if (!drawer) return;

    renderShippingBar(drawer, cart, realTotal);
    try { renderVolumeAndFlammes(drawer, cart, realTotal); } catch (e) {}
    renderIncludedGift(drawer, hasGift, realTotal, threshold || 0);
    renderGiftWidget(drawer, hasGift);
    lockGiftQuantities(drawer);
  }

  // Verrouille la quantit\u00e9 des cadeaux gratuits \u00e0 1 (cache le s\u00e9lecteur).
  // OK BYE : lignes marqu\u00e9es data-okbye-gift par sections/mini-cart.liquid (+ ancien Sent-bon par variante)
  function lockGiftQuantities(drawer) {
    if (!drawer) return;
    var lis = drawer.querySelectorAll('li[data-okbye-gift], li[data-variant-id="' + LEGACY_GIFT.variantId + '"]');
    Array.prototype.forEach.call(lis, function(li) {
      li.classList.add("okbye-gift-line");
      var input = li.querySelector(".quantity__input");
      if (input) {
        input.setAttribute("readonly", "readonly");
        input.setAttribute("tabindex", "-1");
      }
      var links = li.querySelectorAll("a.product-title, a.product-image");
      Array.prototype.forEach.call(links, function(a) {
        a.style.pointerEvents = "none";
        a.setAttribute("tabindex", "-1");
        a.removeAttribute("href");
      });
    });
  }

  // OK BYE v51 — Offre volume (« Ajoute 1 bougie 9 oz de plus pour économiser 5 % »)
  // + « Cette commande te rapporte X flammes », juste sous la barre de livraison.
  function renderVolumeAndFlammes(drawer, cart, realTotal) {
    var VOL = CFG.volume || {};
    var FL = CFG.flammes || {};
    if (!VOL.next) VOL.next = "Ajoute {n} bougie 9 oz de plus pour économiser {pct} %";
    if (!VOL.done) VOL.done = "Tu économises {pct} % sur tes bougies 9 oz";
    var el = document.getElementById("okbye-cart-extras");
    var html = "";

    if (VOL.enabled) {
      var words = String(VOL.keywords || "").toLowerCase().split(",").map(function (w) { return w.trim(); }).filter(Boolean);
      var tiers = String(VOL.tiers || "").split(",").map(function (t) {
        var p = t.split(":"); return { qty: parseInt(p[0], 10), pct: parseFloat(p[1]) };
      }).filter(function (t) { return t.qty > 0 && t.pct > 0; }).sort(function (a, b) { return a.qty - b.qty; });
      var count = 0;
      cart.items.forEach(function (i) {
        if (isGiftLine(i)) return;
        var hay = ((i.variant_title || "") + " " + (i.product_title || "")).toLowerCase();
        if (words.some(function (w) { return hay.indexOf(w) > -1; })) count += i.quantity;
      });
      if (count > 0 && tiers.length) {
        var reached = null, next = null;
        tiers.forEach(function (t) { if (count >= t.qty) reached = t; else if (!next) next = t; });
        var msg = "";
        if (next) {
          msg = String(VOL.next || "").replace("{n}", "<strong>" + (next.qty - count) + "</strong>").replace("{pct}", "<strong>" + next.pct + "</strong>");
          if (reached) msg = String(VOL.done || "").replace("{pct}", reached.pct) + " · " + msg;
        } else if (reached) {
          msg = String(VOL.done || "").replace("{pct}", "<strong>" + reached.pct + "</strong>");
        }
        if (msg) html += '<p class="okbye-cx okbye-cx--vol' + (reached && !next ? ' is-done' : '') + '"><span class="okbye-cx__ico" aria-hidden="true">%</span><span>' + msg + '</span></p>';
      }
    }

    if (FL.enabled && realTotal > 0) {
      var pts = Math.floor(realTotal / 100);
      if (pts > 0) {
        html += '<p class="okbye-cx okbye-cx--fl"><span class="okbye-cx__ico" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21.5c-4 0-7-2.8-7-6.7 0-3.3 2.2-5.5 3.6-7.6.4 1.6 1.3 2.7 2.4 3.3C11 7 12.6 4.3 15.2 2.5c-.3 3 1 4.8 2.3 6.6 1 1.4 1.5 2.9 1.5 4.9 0 4.4-3 7.5-7 7.5z"/></svg>' +
          '</span><span>' + escapeHtml(String(FL.text || "").split("[nombre]")[0]) + '<strong>' + pts + '</strong>' + escapeHtml(String(FL.text || "").split("[nombre]").slice(1).join("")) + '</span></p>';
      }
    }

    if (!html) { if (el) el.remove(); return; }
    if (!el) {
      el = document.createElement("div");
      el.id = "okbye-cart-extras";
      var bar = document.getElementById("okbye-shipping-bar");
      if (bar) bar.insertAdjacentElement("afterend", el); else drawer.prepend(el);
      var st = document.getElementById("okbye-cx-style");
      if (!st) {
        st = document.createElement("style");
        st.id = "okbye-cx-style";
        st.textContent =
          "#okbye-cart-extras{display:grid;gap:6px;padding:8px 16px 4px}" +
          ".okbye-cx{display:flex;align-items:center;gap:8px;margin:0;font-size:13px;line-height:1.35}" +
          ".okbye-cx__ico{flex:0 0 auto;display:inline-flex;align-items:center;justify-content:center;width:22px;height:22px;border-radius:50%;background:#CA201D;color:#fff;font-weight:700;font-size:12px}" +
          ".okbye-cx--fl{color:#CA201D}.okbye-cx--fl .okbye-cx__ico{background:#FBEDEB;color:#CA201D}" +
          ".okbye-cx--vol.is-done .okbye-cx__ico{background:#A9BCA3}";
        document.head.appendChild(st);
      }
    }
    el.innerHTML = html;
  }

  function findFooter() {
    var selectors = [".mini-cart__footer", ".cart-drawer__footer", ".mini-cart__buttons", "[data-mini-cart-footer]"];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    var btn = document.querySelector('[name="checkout"], .mini-cart__checkout, .cart__checkout-button');
    return btn ? (btn.closest("div[class*='footer'], footer, form") || btn.parentElement) : null;
  }

  function findItemsTop() {
    // Top du contenu du drawer (avant les items)
    var selectors = [".mini-cart__items", ".cart-drawer__items", "[data-mini-cart-items]", ".mini-cart__scroll"];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  // \u2500\u2500\u2500 1. FREE SHIPPING BAR style Rhode \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500

  // Cadeau inclus (sent-bon) \u2014 bandeau info, ajout\u00e9 automatiquement, pas de bouton
  // OK BYE : le bandeau DISPARA\u00ceT d\u00e8s que le cadeau est dans le panier (la ligne du cadeau porte
  // alors sa propre petite note, rendue dans sections/mini-cart.liquid). Avec un seuil > 0, il affiche
  // \u00ab Plus que X $ pour ton cadeau \u00bb + une mini barre de progression tant que le seuil n'est pas atteint.
  function renderIncludedGift(drawer, hasGift, realTotal, threshold) {
    var el = document.getElementById("okbye-included-gift");
    if (hasGift || !INCLUDED_GIFT.available) {
      if (el) el.remove();
      return;
    }
    if (!el) {
      el = document.createElement("div");
      el.id = "okbye-included-gift";
      var bar = document.getElementById("okbye-shipping-bar");
      if (bar) { bar.insertAdjacentElement("afterend", el); }
      else { drawer.prepend(el); }
    }
    var label = escapeHtml(INCLUDED_GIFT.displayLabel);
    var img = giftImages[INCLUDED_GIFT.handle] || "";
    var imgHTML = img
      ? '<img src="' + escapeHtml(img) + '" alt="' + label + '" class="okbye-inc-img" />'
      : '<div class="okbye-inc-img okbye-inc-img--placeholder"></div>';

    var remaining = threshold - realTotal;
    var tagHTML, progressHTML = '';
    if (threshold > 0 && remaining > 0) {
      var parts = String(TEXT_PROGRESS).split("{montant}");
      tagHTML = parts.map(escapeHtml).join('<strong>' + formatMoneyShort(remaining) + '</strong>');
      var pct = Math.max(4, Math.min(100, (realTotal / threshold) * 100));
      progressHTML = '<span class="okbye-inc-track" aria-hidden="true"><span class="okbye-inc-fill" style="width:' + pct.toFixed(1) + '%"></span></span>';
    } else {
      tagHTML = escapeHtml(TEXT_BANNER);
    }

    var html =
      '<div class="okbye-inc-wrap' + (progressHTML ? ' okbye-inc-wrap--progress' : '') + '">' +
        imgHTML +
        '<div class="okbye-inc-info">' +
          '<p class="okbye-inc-tag">' + tagHTML + '</p>' +
          '<p class="okbye-inc-name">' + label + '</p>' +
          progressHTML +
        '</div>' +
        '<span class="okbye-inc-free">GRATUIT</span>' +
      '</div>';
    // Ne r\u00e9-\u00e9crit que si le contenu change (\u00e9vite des mutations inutiles)
    if (el.__okbyeHtml !== html) { el.innerHTML = html; el.__okbyeHtml = html; }
  }

  function renderShippingBar(drawer, cart, realTotal) {
    var bar = document.getElementById("okbye-shipping-bar");
    if (!bar) {
      bar = document.createElement("div");
      bar.id = "okbye-shipping-bar";
      // Injecte tout en haut du drawer, avant les items
      var top = findItemsTop();
      if (top) {
        top.parentElement.insertBefore(bar, top);
      } else {
        drawer.prepend(bar);
      }
    }

    var itemCount = 0;
    cart.items.forEach(function(i) {
      if (!isGiftLine(i)) itemCount += i.quantity;
    });

    var remaining = FREE_SHIPPING_THRESHOLD - realTotal;
    var progressPct = Math.min((realTotal / FREE_SHIPPING_THRESHOLD) * 100, 100);

    var msg = "";
    var fillColor = "#1A1A1A";
    // v77 : camion + message plus direct ; rouge quand il manque peu
    var truck = '<svg class="okbye-bar-truck" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>';
    if (remaining <= 0) {
      msg = '<span class="okbye-bar-done">' + truck + '<span>Livraison gratuite d\u00e9bloqu\u00e9e \u2713</span></span>';
      fillColor = "#2E7D4F";
    } else {
      var remainingFormatted = (remaining / 100).toFixed(2).replace(".", ",").replace(",00", "");
      msg = truck + "<span>Plus que <strong>" + remainingFormatted + " $</strong> pour la livraison gratuite</span>";
      if (remaining <= 3000) fillColor = "#CA201D";
    }

    bar.innerHTML =
      '<div class="okbye-bar-inner">' +
        '<div class="okbye-bar-top">' +
          '<span class="okbye-bar-count">' + itemCount + ' article' + (itemCount > 1 ? 's' : '') + '</span>' +
          '<span class="okbye-bar-msg">' + msg + '</span>' +
        '</div>' +
        '<div class="okbye-bar-track" style="height:7px !important;width:100% !important;background:#E6E2DA !important;border-radius:99px;overflow:hidden;display:block !important">' +
          '<div class="okbye-bar-fill" style="width:' + progressPct + '% !important;height:7px !important;min-width:6px;background:' + fillColor + ' !important;border-radius:99px;display:block !important"></div>' +
        '</div>' +
      '</div>';
  }

  // \u2500\u2500\u2500 2. T-SHIRT BLOC style Kylie \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500

  function renderTshirtBloc(drawer, realTotal, hasTshirt) {
    var bloc = document.getElementById("okbye-tshirt-bloc");
    if (!bloc) {
      bloc = document.createElement("div");
      bloc.id = "okbye-tshirt-bloc";
      // Place juste apr\u00e8s la shipping bar
      var bar = document.getElementById("okbye-shipping-bar");
      if (bar && bar.nextSibling) {
        bar.parentElement.insertBefore(bloc, bar.nextSibling);
      } else {
        var top = findItemsTop();
        if (top) top.parentElement.insertBefore(bloc, top);
      }
      bloc.addEventListener("click", handleTshirtClick);
    }

    var unlocked = realTotal >= TSHIRT.threshold;
    var remaining = ((TSHIRT.threshold - realTotal) / 100).toFixed(2).replace(".", ",");
    var imgHTML = tshirtImage
      ? '<img src="' + tshirtImage + '" alt="' + TSHIRT.displayLabel + '" class="okbye-ts-img" />'
      : '<div class="okbye-ts-img okbye-ts-img--placeholder"></div>';

    if (hasTshirt) {
      // T-shirt already in cart - hide this block entirely
      bloc.style.display = 'none';
    } else if (unlocked) {
      // D\u00e9bloqu\u00e9 mais pas encore ajout\u00e9
      bloc.innerHTML =
        '<div class="okbye-ts-inner okbye-ts-inner--unlocked">' +
          imgHTML +
          '<div class="okbye-ts-info">' +
            '<p class="okbye-ts-label">\ud83c\udf89 ' + TSHIRT.unlockedMsg + '</p>' +
            '<p class="okbye-ts-sub">' + TSHIRT.displayLabel + '</p>' +
            '<p class="okbye-ts-price"><s>' + TSHIRT.comparePrice + '</s> <strong>GRATUIT</strong></p>' +
          '</div>' +
          '<button id="okbye-ts-btn" class="okbye-ts-btn" type="button">Ajouter</button>' +
        '</div>';
    } else {
      // Pas encore d\u00e9bloqu\u00e9
      var desc = TSHIRT.description.replace("%REMAINING%", "<strong>" + remaining + " $</strong>");
      bloc.innerHTML =
        '<div class="okbye-ts-inner">' +
          imgHTML +
          '<div class="okbye-ts-info">' +
            '<p class="okbye-ts-label">' + desc + '</p>' +
            '<p class="okbye-ts-sub">' + TSHIRT.displayLabel + '</p>' +
            '<p class="okbye-ts-price"><s>' + TSHIRT.comparePrice + '</s> GRATUIT</p>' +
          '</div>' +
        '</div>';
    }
  }

  async function handleTshirtClick(e) {
    var btn = e.target.closest("#okbye-ts-btn");
    if (!btn || btn.disabled) return;
    e.preventDefault(); e.stopPropagation();
    btn.textContent = "...";
    btn.disabled = true;
    try {
      await addToCart(TSHIRT.variantId, { _gift: "true" });
      await refreshNativeCart();
      clickListenerAttached = false;
      await syncAndRender();
    } catch(err) {
      btn.textContent = "Erreur";
      btn.disabled = false;
    }
  }

  // \u2500\u2500\u2500 3. GIFT WIDGET (cadeau choix) \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500

  function renderGiftWidget(drawer, giftAdded, _attempt) {
    var footer = findFooter();
    if (!footer) {
      // Footer not ready yet (mobile loads slower) - retry up to 5x
      var attempt = (_attempt || 0) + 1;
      if (attempt <= 5) {
        setTimeout(function() { renderGiftWidget(drawer, giftAdded, attempt); }, 200 * attempt);
      }
      return;
    }

    var widget = document.getElementById("okbye-gift-widget");
    if (!widget) {
      widget = document.createElement("div");
      widget.id = "okbye-gift-widget";
    }
    // v77 : la suggestion va sous les articles, dans la zone qui défile. Le pied collé garde
    // seulement le total et le bouton de paiement (plus d'espace pour les articles sur mobile).
    var itemsEnd = drawer.querySelector(".mini-cart__main cart-items");
    if (itemsEnd) {
      if (widget.previousElementSibling !== itemsEnd) itemsEnd.insertAdjacentElement("afterend", widget);
    } else if (widget.parentElement !== footer) {
      footer.insertBefore(widget, footer.firstChild);
    }

    renderUpsell(widget);

    if (!clickListenerAttached) {
      widget.addEventListener("click", handleGiftClick);
      clickListenerAttached = true;
    }
    // v70 : menu de format (Mini / Régulier) → change la variante ajoutée et le prix du bouton
    if (!widget.dataset.okbyeChange) {
      widget.dataset.okbyeChange = "1";
      widget.addEventListener("change", function(e) {
        var sel = e.target.closest(".okbye-upsell-select");
        if (!sel) return;
        var h = sel.dataset.handle, vid = Number(sel.value);
        var v = (upsellVariants[h] || []).filter(function(x) { return Number(x.id) === vid; })[0];
        upsellAddVariant[h] = vid;
        if (v) {
          upsellPrices[h] = v.price;
          if (v.compare && v.compare > v.price) { upsellCompare[h] = v.compare; upsellOnSale[h] = true; }
          else { upsellOnSale[h] = false; }
        }
        renderUpsell(widget);
      });
    }
  }

  async function handleGiftClick(e) {
    var choiceBtn = e.target.closest(".okbye-gift-choice");
    if (choiceBtn) {
      e.preventDefault(); e.stopPropagation();
      selectedGiftIndex = parseInt(choiceBtn.dataset.gift);
      var gw = document.getElementById("okbye-gift-widget");
      if (gw) renderGiftSelector(gw);
      return;
    }

    var giftBtn = e.target.closest("#okbye-gift-btn");
    if (giftBtn && !giftBtn.disabled) {
      e.preventDefault(); e.stopPropagation();
      giftBtn.textContent = "...";
      giftBtn.disabled = true;
      try {
        await addToCart(GIFTS[selectedGiftIndex].variantId, { _gift: "true", _okbye_gift: "true" });
        currentUpsellIndex = 0;
        await refreshNativeCart();
        clickListenerAttached = false;
        isSyncing = false; // Force reset before re-render
        await syncAndRender();
      } catch(err) {
        giftBtn.textContent = "Erreur";
        giftBtn.disabled = false;
      }
      return;
    }

    var upsellBtn = e.target.closest("#okbye-upsell-btn");
    if (upsellBtn && !upsellBtn.disabled) {
      e.preventDefault(); e.stopPropagation();
      var id = parseInt(upsellBtn.dataset.id);
      upsellBtn.textContent = "...";
      upsellBtn.disabled = true;
      try {
        await addToCart(id);
        await refreshNativeCart();
        clickListenerAttached = false;
        debouncedSync();
      } catch(err) {
        upsellBtn.textContent = "Erreur";
        upsellBtn.disabled = false;
      }
      return;
    }

    var detailsBtn = e.target.closest("#okbye-details-toggle");
    if (detailsBtn) {
      e.preventDefault(); e.stopPropagation();
      detailsOpen = !detailsOpen;
      var panel = document.getElementById("okbye-details-panel");
      var label = document.getElementById("okbye-details-label");
      if (panel) panel.style.display = detailsOpen ? "block" : "none";
      if (label) label.textContent = detailsOpen ? "fermer les d\u00e9tails" : "plus de d\u00e9tails";
      return;
    }

    var closeBtn = e.target.closest("#okbye-details-close");
    if (closeBtn) {
      e.preventDefault(); e.stopPropagation();
      detailsOpen = false;
      var panel = document.getElementById("okbye-details-panel");
      var label = document.getElementById("okbye-details-label");
      if (panel) panel.style.display = "none";
      if (label) label.textContent = "plus de d\u00e9tails";
      return;
    }

    var prevBtn = e.target.closest("#okbye-upsell-prev");
    if (prevBtn) { e.preventDefault(); e.stopPropagation(); currentUpsellIndex = currentUpsellIndex - 1; clickListenerAttached = false; renderGiftWidget(document.querySelector("#mini-cart"), true); return; }

    var nextBtn = e.target.closest("#okbye-upsell-next");
    if (nextBtn) { e.preventDefault(); e.stopPropagation(); currentUpsellIndex = currentUpsellIndex + 1; clickListenerAttached = false; renderGiftWidget(document.querySelector("#mini-cart"), true); return; }
  }

  function renderGiftSelector(container) {
    var gift = GIFTS[selectedGiftIndex];
    var imgUrl = giftImages[gift.handle] || "";
    var choicesHTML = GIFTS.map(function(g, i) {
      return '<button type="button" class="okbye-gift-choice' + (i === selectedGiftIndex ? ' okbye-gift-choice--on' : '') + '" data-gift="' + i + '">' + g.displayLabel + '</button>';
    }).join("");
    var imgHTML = imgUrl
      ? '<img id="okbye-gift-img" src="' + imgUrl + '" alt="' + gift.displayLabel + '" class="okbye-gift-img" />'
      : '<div class="okbye-gift-img okbye-gift-img--placeholder"></div>';

    container.innerHTML =
      '<div class="okbye-widget">' +
        '<div class="okbye-gift-label"><span class="okbye-gift-tag">CHOISIS TON CADEAU GRATUIT &mdash; ON TE G&Acirc;TE &lt;3</span></div>' +
        '<div class="okbye-gift-body">' +
          '<div class="okbye-gift-img-wrap">' + imgHTML + '</div>' +
          '<div class="okbye-gift-info">' +
            '<div class="okbye-gift-choices">' + choicesHTML + '</div>' +
          '</div>' +
          (cartIsEmpty
            ? '<button id="okbye-gift-btn" class="okbye-gift-btn" type="button" disabled>Avec ta commande</button>'
            : '<button id="okbye-gift-btn" class="okbye-gift-btn" type="button">Ajouter</button>') +
        '</div>' +
        '<div class="okbye-details-bar">' +
          '<button id="okbye-details-toggle" class="okbye-details-toggle" type="button">' +
            '<span id="okbye-details-label">plus de d\u00e9tails</span>' +
            '<svg viewBox="0 0 10 6" width="10" height="6" style="margin-left:4px;opacity:.5"><path d="M0 0l5 6 5-6z" fill="currentColor"/></svg>' +
          '</button>' +
        '</div>' +
        '<div id="okbye-details-panel" class="okbye-details-panel" style="display:none;">' +
          '<button id="okbye-details-close" class="okbye-details-close" type="button">&times;</button>' +
          '<div class="okbye-details-inner">' +
            (imgUrl ? '<img src="' + imgUrl + '" alt="' + gift.displayLabel + '" class="okbye-details-img" />' : '') +
            '<div class="okbye-details-content">' +
              '<p class="okbye-details-title">Cadeau gratuit avec ta commande</p>' +
              '<p class="okbye-details-text">' + DETAILS_TEXT + '</p>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';

  }

  function renderUpsell(container) {
    // Rhode-style: ne sugg\u00e8re que des produits PAS d\u00e9j\u00e0 dans le panier, cycle sans fin
    var available = UPSELLS.filter(function(u) {
      var addId = upsellAddVariant[u.handle] || u.variantId;
      if (addId == null) return false;
      // OK BYE : produit déjà au panier (n'importe quelle variante) → caché
      if (u.productId && currentCartProductIds.indexOf(u.productId) !== -1) return false;
      return currentCartVariantIds.indexOf(u.variantId) === -1 && currentCartVariantIds.indexOf(addId) === -1;
    });
    if (available.length === 0) {
      container.innerHTML = '';
      container.style.display = 'none';
      return;
    }
    container.style.display = '';
    // Normalise l'index (wrap des deux bords, jamais de cul-de-sac)
    currentUpsellIndex = ((currentUpsellIndex % available.length) + available.length) % available.length;
    var u = available[currentUpsellIndex];
    var img = upsellImages[u.handle] || "";
    var imgHTML = img
      ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(u.displayLabel) + '" class="okbye-upsell-img" />'
      : '<div class="okbye-upsell-img okbye-upsell-img--placeholder"></div>';
    var progress = (currentUpsellIndex + 1) + " / " + available.length;

    var priceHTML = '';
    if (upsellOnSale[u.handle] && upsellCompare[u.handle] != null) {
      priceHTML = '<span class="okbye-upsell-price"><s class="okbye-upsell-was">' + formatMoney(upsellCompare[u.handle]) + '</s> <span class="okbye-upsell-now">' + formatMoney(upsellPrices[u.handle]) + '</span></span>';
    } else if (upsellPrices[u.handle] != null) {
      priceHTML = '<span class="okbye-upsell-price">' + formatMoney(upsellPrices[u.handle]) + '</span>';
    }
    var badgeHTML = u.badge ? '<span class="okbye-upsell-badge">' + u.badge + '</span>' : '';

    // v70 : menu de format quand le produit en a plusieurs (sauf produits \u00e0 options : on va sur leur page)
    var vars = upsellVariants[u.handle] || [];
    var selectedId = upsellAddVariant[u.handle] || u.variantId;
    var selectHTML = '';
    if (!u.options && vars.length > 1) {
      selectHTML = '<select class="okbye-upsell-select" data-handle="' + escapeHtml(u.handle) + '" aria-label="Format">' +
        vars.map(function(v) {
          return '<option value="' + v.id + '"' + (Number(v.id) === Number(selectedId) ? ' selected' : '') + '>' + escapeHtml(v.title) + '</option>';
        }).join('') + '</select>';
    }
    var priceLabel = upsellPrices[u.handle] != null ? ' \u2013 ' + formatMoney(upsellPrices[u.handle]) : '';
    var navHTML = available.length > 1
      ? '<span class="okbye-upsell-arrows">' +
          '<button class="okbye-upsell-skip" id="okbye-upsell-prev" type="button" aria-label="Pr\u00e9c\u00e9dent">&#8249;</button>' +
          '<span class="okbye-upsell-progress">' + progress + '</span>' +
          '<button class="okbye-upsell-skip" id="okbye-upsell-next" type="button" aria-label="Suivant">&#8250;</button>' +
        '</span>'
      : '';

    container.innerHTML =
      '<div class="okbye-widget okbye-widget--rhode">' +
        '<div class="okbye-upsell-header">' +
          '<p class="okbye-upsell-title">' + escapeHtml(UPSELL_HEADING) + '</p>' + navHTML +
        '</div>' +
        '<div class="okbye-upsell-card">' +
          imgHTML +
          '<span class="okbye-upsell-meta"><span class="okbye-upsell-name">' + escapeHtml(u.displayLabel) + '</span>' +
            (selectHTML || priceHTML) + badgeHTML +
            (u.options && u.url
              ? '<a class="okbye-upsell-btn okbye-upsell-btn--choose" href="' + escapeHtml(u.url) + '">' + (CFG.texts && CFG.texts.choose || 'Choisir') + priceLabel + '</a>'
              : '<button id="okbye-upsell-btn" class="okbye-upsell-btn" type="button" data-id="' + selectedId + '">' + (CFG.texts && CFG.texts.add || 'Ajouter') + priceLabel + '</button>') +
          '</span>' +
        '</div>' +
      '</div>';
  }

  // \u2500\u2500\u2500 STYLES \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500

  // CSS cibl\u00e9 par variant-id pour cacher le stepper des lignes cadeau
  function buildGiftQtyCSS() {
    // OK BYE : lignes marquées data-okbye-gift (mini-cart.liquid) + ancien Sent-bon par variante
    var sel = ['li[data-okbye-gift]', 'li[data-variant-id="' + LEGACY_GIFT.variantId + '"]'];
    return sel.map(function(s) { return s + ' .quantity__button'; }).join(',') + '{display:none!important}' +
           sel.map(function(s) { return s + ' quantity-input.quantity'; }).join(',') + '{border:0!important;height:auto;background:transparent}' +
           sel.map(function(s) { return s + ' .quantity__input'; }).join(',') + '{pointer-events:none;border:0;background:transparent;width:1.6em;min-width:0;padding:0;text-align:center;font-weight:500;color:#6B675F}' +
           sel.map(function(s) { return s + ' a.product-title,' + s + ' a.product-image'; }).join(',') + '{pointer-events:none!important;cursor:default!important;text-decoration:none!important;border-bottom:0!important;background-image:none!important;color:#1A1A1A!important}';
  }

  function injectStyles() {
    if (document.getElementById("okbye-gift-styles")) return;
    var style = document.createElement("style");
    style.id = "okbye-gift-styles";
    style.textContent = [
      /* \u2500\u2500 Shipping bar \u2014 Rhode blend-in \u2500\u2500 */
      "#okbye-shipping-bar{padding:16px 18px 12px;border-bottom:1px solid #E9E6DF;background:#FBFAF7}",
      ".okbye-bar-top{display:flex;align-items:center;justify-content:space-between;gap:8px;margin-bottom:9px}",
      ".okbye-bar-count{font-size:11px;font-weight:500;color:#8C8881;text-transform:uppercase;letter-spacing:.14em}",
      ".okbye-bar-msg{font-size:12px;color:#5E5B54;text-align:right;line-height:1.4}",
      ".okbye-bar-msg strong{color:#1A1A1A;font-weight:500}",
      ".okbye-bar-done{color:#5E7A5C;letter-spacing:.02em}",
      ".okbye-bar-track{height:7px;background:#E6E2DA;border-radius:99px;overflow:hidden}",
      ".okbye-bar-fill{height:100%;min-width:7px;background:#1A1A1A;border-radius:99px;transition:width .4s ease}",
      ".okbye-bar-track--done .okbye-bar-fill{background:#A9BCA3}",
      ".okbye-inc-wrap{display:flex;align-items:center;gap:10px;padding:9px 18px;border-bottom:1px solid #E9E6DF}",
      ".okbye-inc-img{width:40px;height:40px;object-fit:cover;border-radius:7px;flex-shrink:0;border:1px solid #E9E6DF}",
      ".okbye-inc-img--placeholder{width:40px;height:40px;border-radius:7px;background:#EDEAE3;flex-shrink:0}",
      ".okbye-inc-info{flex:1;min-width:0}",
      ".okbye-inc-tag{font-size:11px;font-weight:500;text-transform:uppercase;letter-spacing:.12em;color:#8C8881;margin:0 0 2px}",
      ".okbye-inc-name{font-size:16px;font-weight:500;color:#1A1A1A;margin:0;line-height:1.3}",
      ".okbye-inc-free{font-size:11px;font-weight:500;letter-spacing:.06em;color:#5E7A5C;flex-shrink:0}",
      /* OK BYE : progression vers le cadeau (seuil > 0) */
      ".okbye-inc-wrap--progress{background:#FFFAF6}",
      ".okbye-inc-wrap--progress .okbye-inc-tag{text-transform:none;letter-spacing:.01em;font-size:12px;color:#1A1B18;font-family:var(--font-body-family)}",
      ".okbye-inc-tag strong{color:#CA201D;font-weight:600}",
      ".okbye-inc-track{display:block;height:4px;margin-top:6px;background:#F4EEE8;border-radius:var(--button-radius,40px);overflow:hidden}",
      ".okbye-inc-fill{display:block;height:100%;background:#CA201D;border-radius:var(--button-radius,40px);transition:width .4s ease}",
      /* OK BYE : petite note sous le nom du cadeau (sections/mini-cart.liquid) */
      ".mini-cart .okbye-gift-caption{margin:3px 0 0;font-family:var(--font-body-family);font-size:11px;line-height:1.35;letter-spacing:.02em;color:#CA201D}",

      /* \u2500\u2500 T-shirt bloc style Kylie \u2500\u2500 */
      "#okbye-tshirt-bloc{padding:12px 16px;border-bottom:1px solid #EEE;background:#FFF8F5}",
      ".okbye-ts-inner{display:flex;align-items:center;gap:10px}",
      ".okbye-ts-inner--unlocked{background:#FFF0ED;border-radius:10px;padding:10px;margin:-2px}",
      ".okbye-ts-inner--added{background:#F0FFF4;border-radius:10px;padding:10px;margin:-2px}",
      ".okbye-ts-img{width:56px;height:56px;object-fit:cover;border-radius:8px;flex-shrink:0;border:1px solid #F2D5C8}",
      ".okbye-ts-img--placeholder{width:56px;height:56px;border-radius:8px;background:#F5EDE8;flex-shrink:0}",
      ".okbye-ts-info{flex:1;min-width:0}",
      ".okbye-ts-label{font-size:11px;color:#555;margin:0 0 2px;line-height:1.4}",
      ".okbye-ts-label strong{color:#D94F3D}",
      ".okbye-ts-sub{font-size:12px;font-weight:700;color:#1A1A1A;margin:0 0 2px;line-height:1.3}",
      ".okbye-ts-price{font-size:11px;color:#888;margin:0} .okbye-ts-price strong{color:#3A8C55;font-weight:800}",
      ".okbye-ts-btn{flex-shrink:0;padding:8px 12px;background:#D94F3D;color:#fff;border:none;border-radius:7px;font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:.05em;cursor:pointer;font-family:inherit;white-space:nowrap;pointer-events:all}",
      ".okbye-ts-btn:hover{background:#b83e2e}",
      ".okbye-ts-btn:disabled{opacity:.5;cursor:not-allowed}",

      /* \u2500\u2500 Gift widget \u2014 Rhode blend-in \u2500\u2500 */
      "#okbye-gift-widget{padding:2px 12px 0;font-family:inherit;position:relative;z-index:1}",
      ".okbye-widget{border:1px solid #E9E6DF;border-radius:12px;overflow:hidden;background:#F6F4EF}",
      ".okbye-gift-label{background:transparent;padding:7px 12px 0;text-align:left}",
      ".okbye-gift-tag{font-size:11px;font-weight:500;color:#6B675F;letter-spacing:.14em;text-transform:uppercase;line-height:1.4}",
      ".okbye-gift-body{display:flex;align-items:center;gap:10px;padding:6px 12px 8px}",
      ".okbye-gift-img{width:40px;height:40px;object-fit:cover;border-radius:7px;border:1px solid #E9E6DF;display:block}",
      ".okbye-gift-img--placeholder{width:46px;height:46px;border-radius:7px;background:#EDEAE3}",
      ".okbye-gift-info{flex:1;min-width:0}",
      ".okbye-gift-name{font-size:14px;font-weight:500;color:#1A1A1A;margin:0 0 2px;line-height:1.3}",
      ".okbye-gift-price{font-size:11px;font-weight:500;color:#5E7A5C;letter-spacing:.06em;margin:0 0 5px;text-transform:uppercase}",
      ".okbye-gift-select{width:100%;padding:6px 9px;border:1px solid #E3DFD7;border-radius:7px;font-size:12px;background:#FBFAF7;color:#1A1A1A;cursor:pointer;font-family:inherit;text-overflow:ellipsis;overflow:hidden}",
      ".okbye-gift-select:focus{outline:none;border-color:#1A1A1A}",
      ".okbye-gift-choices{display:flex;flex-wrap:wrap;gap:6px;margin-top:1px}",
      ".okbye-gift-choice{font-size:12px;padding:7px 12px;border:1px solid #E3DFD7;border-radius:20px;background:#FBFAF7;color:#5E5B54;cursor:pointer;font-family:inherit;line-height:1.2;-webkit-tap-highlight-color:transparent}",
      ".okbye-gift-choice--on{border-color:#1A1A1A;background:#1A1A1A;color:#FBFAF7}",
      ".okbye-gift-btn{flex-shrink:0;padding:9px 15px;background:#1A1A1A;color:#FBFAF7;border:none;border-radius:20px;font-size:10.5px;font-weight:500;text-transform:uppercase;letter-spacing:.1em;cursor:pointer;font-family:inherit;white-space:nowrap;pointer-events:all;position:relative;z-index:2}",
      ".okbye-gift-btn:hover{background:#333}",
      ".okbye-gift-btn:disabled{opacity:.45;cursor:not-allowed}",
      ".okbye-details-bar{border-top:1px solid #E9E6DF;padding:6px 12px;background:transparent}",
      ".okbye-details-toggle{background:none;border:none;cursor:pointer;font-size:10.5px;color:#8C8881;font-family:inherit;display:flex;align-items:center;gap:4px;padding:0;text-decoration:underline;text-underline-offset:2px}",
      ".okbye-details-toggle:hover{color:#1A1A1A}",
      ".okbye-details-panel{background:#2B2622;padding:16px 14px;position:relative}",
      ".okbye-details-close{position:absolute;top:10px;right:12px;background:none;border:none;color:#fff;font-size:18px;cursor:pointer;opacity:.7;padding:0}",
      ".okbye-details-close:hover{opacity:1}",
      ".okbye-details-inner{display:flex;gap:12px;align-items:flex-start}",
      ".okbye-details-img{width:70px;height:70px;object-fit:cover;border-radius:8px;border:1px solid rgba(255,255,255,.15);flex-shrink:0}",
      ".okbye-details-content{flex:1}",
      ".okbye-details-title{font-size:11px;font-weight:500;color:#fff;text-transform:uppercase;letter-spacing:.1em;margin:0 0 6px}",
      ".okbye-details-text{font-size:11px;color:rgba(255,255,255,.72);line-height:1.6;margin:0}",
      ".okbye-upsell-header{padding:7px 12px 0;display:flex;align-items:center;justify-content:space-between}",
      ".okbye-upsell-title{font-size:9.5px;font-weight:500;color:#8C8881;text-transform:uppercase;letter-spacing:.12em;margin:0}",
      ".okbye-upsell-progress{font-size:10px;color:#A8A39B;white-space:nowrap}",
      ".okbye-upsell-card{display:flex;align-items:center;gap:10px;padding:6px 12px}",
      ".okbye-upsell-img{width:40px;height:40px;object-fit:cover;border-radius:7px;flex-shrink:0;border:1px solid #E9E6DF}",
      ".okbye-upsell-img--placeholder{width:40px;height:40px;border-radius:7px;background:#EDEAE3;flex-shrink:0}",
      ".okbye-upsell-meta{display:flex;flex-direction:column;gap:1px;flex:1;min-width:0}",
      ".okbye-upsell-name{font-size:13px;color:#1A1A1A;font-weight:500;line-height:1.25;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}",
      ".okbye-upsell-price{font-size:11.5px;color:#8C8881;font-weight:400}",
      ".okbye-upsell-was{color:#D94F3D;text-decoration:line-through;font-weight:400}",
      ".okbye-upsell-now{color:#1A1A1A;font-weight:500;margin-left:2px}",
      ".okbye-upsell-badge{font-size:11px;color:#D94F3D;font-style:italic;margin-top:1px}",
      ".okbye-upsell-btn{flex-shrink:0;padding:6px 12px;text-decoration:none;background:#1A1A1A;color:#FBFAF7;border:none;border-radius:20px;font-size:10px;font-weight:500;text-transform:uppercase;letter-spacing:.1em;cursor:pointer;font-family:inherit;pointer-events:all}",
      ".okbye-upsell-btn:hover{background:#333}",
      ".okbye-upsell-btn:disabled{opacity:.45;cursor:not-allowed}",
      ".okbye-upsell-nav{display:flex;justify-content:space-between;align-items:center;padding:0 12px 7px;margin-top:0}",
      ".okbye-upsell-skip{background:none;border:none;font-size:10px;letter-spacing:.04em;color:#8C8881;cursor:pointer;font-family:inherit;padding:0}",
      ".okbye-upsell-skip:hover{color:#1A1A1A}",
      ".okbye-upsell-done{padding:16px;text-align:center;font-size:13px;color:#1A1A1A;font-weight:500}",
      /* \u2500\u2500 Corps du panier natif \u2014 Rhode blend-in \u2500\u2500 */
      ".mini-cart{background:#FBFAF7;color:#1A1A1A}",
      ".mini-cart__header .title.h4{font-size:1.05rem;font-weight:500;letter-spacing:.01em}",
      ".mini-cart .product-title{font-size:1.125rem;font-weight:500;color:#1A1A1A;text-decoration:none}",
      ".mini-cart .product-container .media{border-radius:7px;overflow:hidden}",
      ".mini-cart quantity-input.quantity{border:1px solid #E3DFD7;border-radius:20px;height:28px;display:inline-flex;align-items:center;overflow:hidden;background:transparent}",
      ".mini-cart .quantity__button{width:28px;height:26px;color:#7A766E}",
      ".mini-cart .quantity__input{width:30px;font-size:.8rem;border:0;background:transparent}",
      ".mini-cart .product-quantity .price{font-weight:500;font-size:.875rem}",
      ".mini-cart__footer .subtotal .label.h3{font-size:1rem;font-weight:500;letter-spacing:.06em;text-transform:uppercase;color:#5E5B54}",
      ".mini-cart__footer .subtotal .value.price{font-size:1.25rem;font-weight:500}",
      ".mini-cart__footer .tax-note{color:#8C8881;font-size:.9rem}",
      ".mini-cart__footer .button-container .button[name=checkout]{width:100%;background:#1A1A1A;color:#FBFAF7;border:0;border-radius:24px;min-height:50px;font-size:1.025rem;letter-spacing:.08em;text-transform:uppercase;font-weight:500}",
      /* Cache Remarque + Livraison (Be Yours exact) */
      ".mini-cart__actions{display:none!important}",
      /* Cache Voir le panier (Be Yours exact) */
      ".mini-cart__footer .button-container a.button{display:none!important}",
      /* Items scrollables */
      "#mini-cart{display:flex;flex-direction:column;overflow:hidden}",
      "#mini-cart>form{display:flex;flex-direction:column;flex:1;overflow:hidden;min-height:0}",
      ".mini-cart__inner{display:flex;flex-direction:column;flex:1;min-height:0}",
      ".mini-cart__main{flex:1 1 auto;overflow-y:auto;-webkit-overflow-scrolling:touch;min-height:0}",
      ".mini-cart__items{flex:1;overflow-y:auto;-webkit-overflow-scrolling:touch;min-height:60px}",
      ".mini-cart__footer{flex-shrink:0}",
      /* Make mini-cart items scrollable so footer is always visible */
      "#mini-cart{display:flex;flex-direction:column;max-height:100vh}",
      ".mini-cart__items,.cart-drawer__items{flex:1;overflow-y:auto;-webkit-overflow-scrolling:touch}",
      /* Ensure footer stays at bottom */
      ".mini-cart__footer,.cart-drawer__footer{flex-shrink:0}",
    ].join("") + buildGiftQtyCSS();
    document.head.appendChild(style);
  }

  // \u2500\u2500\u2500 OBSERVER \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500

  function observeCart() {
    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        var target = m.target;
        // OK BYE : #okbye-included-gift ajouté ici (ses re-rendus relançaient une synchro en boucle)
        if (["okbye-shipping-bar","okbye-tshirt-bloc","okbye-gift-widget","okbye-tshirt-banner","okbye-included-gift"].indexOf(target.id) !== -1) continue;
        if (target.closest && target.closest("#okbye-shipping-bar,#okbye-tshirt-bloc,#okbye-gift-widget,#okbye-tshirt-banner,#okbye-included-gift")) continue;
        if (target.id === "mini-cart" || (target.closest && target.closest("#mini-cart"))) {
          clickListenerAttached = false;
          debouncedSync();
          return;
        }
        for (var j = 0; j < m.addedNodes.length; j++) {
          var node = m.addedNodes[j];
          if (node.nodeType !== 1) continue;
          if (node.id === "mini-cart" || (node.querySelector && node.querySelector("#mini-cart,.mini-cart__footer"))) {
            clickListenerAttached = false;
            debouncedSync();
            return;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // \u2500\u2500\u2500 INIT \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500

  function init() {
    injectStyles();
    observeCart();
    // Be Yours cart events
    ["cartdrawer:opened", "cart:open", "drawer:open", "miniCart:open"].forEach(function(evt) {
      document.addEventListener(evt, function() {
        clickListenerAttached = false;
        debouncedSync(200);
      });
    });

    // Tshirt events - refresh native cart then re-render
    document.addEventListener("okbye:tshirt-added", function() {
      refreshNativeCart().then(function() {
        clickListenerAttached = false;
        isSyncing = false;
        debouncedSync(150);
      });
    });
    document.addEventListener("okbye:tshirt-removed", function() {
      refreshNativeCart().then(function() {
        clickListenerAttached = false;
        isSyncing = false;
        debouncedSync(150);
      });
    });
    // Signal from okbye-tshirt-banner after it refreshes the native cart
    document.addEventListener("okbye:cart-refreshed", function() {
      isSyncing = false;
      pendingSync = false;
      clickListenerAttached = false;
      debouncedSync(50);
    });
    // Listen on any element that opens the cart (Be Yours uses various selectors)
    document.addEventListener("click", function(e) {
      var cartTrigger = e.target.closest('[data-mini-cart-toggle], [aria-controls="mini-cart"], .js-mini-cart-toggle, .js-drawer-open-cart, [href="#cart-drawer"], .header__icon--cart');
      if (cartTrigger) {
        // Cart icon clicked - sync after drawer animation (~300ms on mobile)
        setTimeout(function() { debouncedSync(100); }, 350);
        setTimeout(function() { debouncedSync(100); }, 700); // second attempt for slow mobile
      }
    }, true); // capture phase to catch before Be Yours
    document.addEventListener("click", function(e) {
      var addBtn = e.target.closest('[name="add"], [data-add-to-cart], .product-form__submit');
      if (addBtn) debouncedSync();
    });
    syncAndRender();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

})();
